(function () {
  var MOBILE_QUERY = '(max-width: 980px)';
  var reduceMotion = window.matchMedia('(prefers-reduced-motion: reduce)');

  function initReviews(root) {
    if (!root || root.dataset.customReviewsReady) return;
    var track = root.querySelector('[data-track]');
    if (!track) return;
    var originals = Array.prototype.slice.call(track.children);
    if (originals.length < 2) return;
    root.dataset.customReviewsReady = 'true';

    var count = originals.length;
    // Enough hidden copies on each side to cover two desktop pages (3 cards each).
    var copies = Math.max(1, Math.ceil(6 / count));

    function makeClone(card) {
      var copy = card.cloneNode(true);
      copy.setAttribute('aria-hidden', 'true');
      copy.removeAttribute('data-shopify-editor-block');
      copy.querySelectorAll('[role="img"]').forEach(function (el) {
        el.removeAttribute('aria-label');
        el.removeAttribute('role');
      });
      return copy;
    }

    var before = document.createDocumentFragment();
    var after = document.createDocumentFragment();
    for (var c = 0; c < copies; c++) {
      originals.forEach(function (card) {
        before.appendChild(makeClone(card));
        after.appendChild(makeClone(card));
      });
    }
    track.insertBefore(before, track.firstChild);
    track.appendChild(after);

    function perView() {
      return window.matchMedia(MOBILE_QUERY).matches ? 1 : 3;
    }

    function step() {
      var gap = parseFloat(window.getComputedStyle(track).columnGap) || 0;
      return originals[0].getBoundingClientRect().width + gap;
    }

    function setWidth() {
      return step() * count;
    }

    function jumpTo(left) {
      track.style.scrollBehavior = 'auto';
      track.scrollLeft = left;
      track.getBoundingClientRect();
      track.style.scrollBehavior = '';
    }

    function goToStart() {
      jumpTo(setWidth() * copies);
    }

    var settleTimer = null;
    track.addEventListener(
      'scroll',
      function () {
        window.clearTimeout(settleTimer);
        settleTimer = window.setTimeout(function () {
          var width = setWidth();
          var half = step() / 2;
          if (track.scrollLeft >= (copies + 1) * width - half) {
            jumpTo(track.scrollLeft - width);
          } else if (track.scrollLeft < copies * width - half) {
            jumpTo(track.scrollLeft + width);
          }
        }, 180);
      },
      { passive: true }
    );

    function page(direction) {
      track.scrollBy({
        left: direction * step() * perView(),
        behavior: reduceMotion.matches ? 'auto' : 'smooth',
      });
    }

    var prev = root.querySelector('[data-prev]');
    var next = root.querySelector('[data-next]');
    if (prev) {
      prev.addEventListener('click', function () {
        page(-1);
      });
    }
    if (next) {
      next.addEventListener('click', function () {
        page(1);
      });
    }

    var lastPerView = perView();
    var resizeFrame = null;
    window.addEventListener('resize', function () {
      if (resizeFrame) return;
      resizeFrame = window.requestAnimationFrame(function () {
        resizeFrame = null;
        var current = perView();
        if (current !== lastPerView) {
          lastPerView = current;
          goToStart();
        }
      });
    });

    window.requestAnimationFrame(function () {
      window.requestAnimationFrame(goToStart);
    });
  }

  function initAll() {
    document.querySelectorAll('[data-custom-reviews]').forEach(initReviews);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initAll);
  } else {
    initAll();
  }

  document.addEventListener('shopify:section:load', function (event) {
    initReviews(event.target.querySelector('[data-custom-reviews]'));
  });

  // Theme editor: bring the selected review into view.
  document.addEventListener('shopify:block:select', function (event) {
    var card = event.target;
    if (!card.closest || !card.closest('[data-custom-reviews]')) return;
    window.requestAnimationFrame(function () {
      window.requestAnimationFrame(function () {
        window.requestAnimationFrame(function () {
          card.scrollIntoView({
            block: 'nearest',
            inline: 'start',
            behavior: event.detail && event.detail.load ? 'auto' : 'smooth',
          });
        });
      });
    });
  });
})();